import styles from './PartnerTerritoryInfo.module.scss'

export const PartnerTerritoryInfo = () => {
  return (
    <div className={styles.importantText}>
      <u>Important:</u>
      <br></br>1. If your selection includes country clusters, it's possible that certain countries
      are also present on the markets.{' '}
      <b>
        <u>Do not</u> remove manually any countries from the markets
      </b>{' '}
      as this will result in the complete removal of those countries from the resulting list.
      <br></br>
      2. The markets are also part of the options, just to facilitate the search of any individual
      countries. Please{' '}
      <b>
        <u>do not</u> select entire markets
      </b>
      , as technically they are not valid options to select.
    </div>
  )
}
